import { useContext } from "react"

import Profile from "@/context/ProfileContext"

export const useProfile = () => {
  return useContext(Profile)
}

export default useProfile
